export const getPortalVisualKind = (route = {}) =>
  route.name === 'The Rift Warden' ? 'Warden' : route.kind;

// Shared by the opening and its frame so even irregular silhouettes stay aligned.
export const getPortalOutlinePoint = (kind, angle, rx = 1, ry = 1) => {
  const x = Math.cos(angle);
  const y = Math.sin(angle);
  const power = (value, exponent) =>
    Math.sign(value) * Math.abs(value) ** exponent;
  let px = x;
  let py = y;
  switch (kind) {
    case 'Warden': {
      const radius = 0.9 + Math.cos(angle * 8) * 0.1;
      px *= radius;
      py *= radius;
      break;
    }
    case 'Supply':
      px = power(x, 0.57);
      py = power(y, 0.57);
      break;
    case 'Core':
    case 'Treasure': {
      const sector = Math.PI / 3;
      const local =
        ((angle - Math.PI / 2 + sector / 2 + Math.PI * 4) % sector) -
        sector / 2;
      const radius = Math.cos(sector / 2) / Math.cos(local);
      px *= radius;
      py *= radius;
      break;
    }
    case 'Sanctuary':
      px = power(x, 1.35) * (0.86 + y * 0.14);
      break;
    case 'Trial': {
      const radius = 1 / (Math.abs(x) + Math.abs(y));
      px *= radius;
      py *= radius;
      break;
    }
    case 'Anomaly': {
      const fracture =
        1 +
        Math.sin(angle * 3 + 0.6) * 0.09 +
        Math.sin(angle * 7 - 0.8) * 0.055;
      px = x * fracture + Math.sin(angle * 2) * 0.07;
      py = y * fracture;
      break;
    }
    case 'Bonus Relic':
      px = power(x, 1.6);
      py = power(y, 0.9);
      break;
    case 'Salvage':
      px = power(x, 0.8) * (1 + y * 0.055);
      py = power(y, 0.7);
      break;
    default:
      break;
  }
  return { x: px * rx, y: py * ry };
};

export const PORTAL_SURFACE_VARIANTS = {
  Supply: 1,
  Treasure: 2,
  Recovery: 3,
  Sanctuary: 4,
  Trial: 5,
  Anomaly: 6,
  'Bonus Relic': 7,
  Salvage: 8,
  Core: 9,
  Warden: 10,
};
